module.exports = __webpack_public_path__ + "static/media/PGL01@l.f9ea0c1f.jpg";